import { cn } from '@/lib/utils';
import type { SVGProps } from 'react';

export function SixDots(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 8"
      fill="none"
      aria-hidden="true"
      {...props}
      className={cn('w-[14px] h-[8px] fill-primary stroke-primary stroke-[1.5px]', props.className)}
    >
      <path
        d="M7.5 2.12598C7.77614 2.12598 8 1.90212 8 1.62598C8 1.34983 7.77614 1.12598 7.5 1.12598C7.22386 1.12598 7 1.34983 7 1.62598C7 1.90212 7.22386 2.12598 7.5 2.12598Z"
        fillOpacity="0.5"
        strokeOpacity="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 2.37402C12.5261 2.37402 12.75 2.15017 12.75 1.87402C12.75 1.59788 12.5261 1.37402 12.25 1.37402C11.9739 1.37402 11.75 1.59788 11.75 1.87402C11.75 2.15017 11.9739 2.37402 12.25 2.37402Z"
        fillOpacity="0.5"
        strokeOpacity="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 2.37402C2.02614 2.37402 2.25 2.15017 2.25 1.87402C2.25 1.59788 2.02614 1.37402 1.75 1.37402C1.47386 1.37402 1.25 1.59788 1.25 1.87402C1.25 2.15017 1.47386 2.37402 1.75 2.37402Z"
        fillOpacity="0.5"
        strokeOpacity="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 6.87402C7.27614 6.87402 7.5 6.65017 7.5 6.37402C7.5 6.09788 7.27614 5.87402 7 5.87402C6.72386 5.87402 6.5 6.09788 6.5 6.37402C6.5 6.65017 6.72386 6.87402 7 6.87402Z"
        fillOpacity="0.5"
        strokeOpacity="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 6.87402C12.5261 6.87402 12.75 6.65017 12.75 6.37402C12.75 6.09788 12.5261 5.87402 12.25 5.87402C11.9739 5.87402 11.75 6.09788 11.75 6.37402C11.75 6.65017 11.9739 6.87402 12.25 6.87402Z"
        fillOpacity="0.5"
        strokeOpacity="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.75 6.87402C2.02614 6.87402 2.25 6.65017 2.25 6.37402C2.25 6.09788 2.02614 5.87402 1.75 5.87402C1.47386 5.87402 1.25 6.09788 1.25 6.37402C1.25 6.65017 1.47386 6.87402 1.75 6.87402Z"
        fillOpacity="0.5"
        strokeOpacity="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
